import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {PrimaryButtonComponent} from './primary-button/primary-button.component';
import {ButtonComponent} from './core/button.component';
import {SecondaryButtonComponent} from './secondary-button/secondary-button.component';
import {GhostButtonComponent} from './ghost-button/ghost-button.component';
import {TertiaryButtonComponent} from './tertiary-button/tertiary-button.component';
import {CircularButtonComponent} from './circular-button/circular-button.component';
import {GradientButtonComponent} from './gradient-button/gradient-button.component';
import {PrimaryFlexButtonComponent} from './primary-flex-button/primary-flex-button.component';
import { MarkCompleteButtonComponent } from './mark-complete-button/mark-complete-button.component';

@NgModule({
  imports: [
    CommonModule,
  ],
  declarations: [
    PrimaryButtonComponent,
    PrimaryFlexButtonComponent,
    ButtonComponent,
    SecondaryButtonComponent,
    GhostButtonComponent,
    TertiaryButtonComponent,
    CircularButtonComponent,
    GradientButtonComponent,
    MarkCompleteButtonComponent,
  ],
  exports: [
    PrimaryButtonComponent,
    PrimaryFlexButtonComponent,
    SecondaryButtonComponent,
    GhostButtonComponent,
    TertiaryButtonComponent,
    CircularButtonComponent,
    GradientButtonComponent,
    MarkCompleteButtonComponent,
  ],
  providers: [],
})
export class ButtonsModule {
}
